import { Leaderboard } from "../spinTheWheel"
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";


import { useTheme, useLoyalty } from "../../../hooks";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";

const CapturenShareLeaderboard = () => {
  const { themeContext, theme } = useTheme();
  const { } = useLoyalty();

  const history = useHistory();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "CaptureAndShareLeaderboard",
        firebase_screen_class: "CaptureAndShareLeaderboard",
      })
    );
  }, []);

  return <Leaderboard backAction={() => history.goBack()}/>
};

export default CapturenShareLeaderboard;